import type { MapAssetStatListProps } from "../../contracts/map-assets";
import { cn } from "../../lib/utils";

export function MapAssetStatList({ items, className }: MapAssetStatListProps) {
  if (!items.length) return null;

  return (
    <div className={cn("flex flex-wrap items-center gap-x-4 gap-y-2", className)}>
      {items.map((item) => (
        <div key={item.id} className="flex flex-col">
          <span className="text-[10px] font-bold uppercase tracking-tight text-muted-foreground/70">
            {item.label}
          </span>
          <div className="flex items-baseline gap-1.5">
            <span
              className={cn(
                "text-xs font-black tabular-nums",
                item.tone === "danger" && "text-destructive",
                item.tone === "warning" && "text-warning",
                item.tone === "success" && "text-success",
                item.tone === "muted" && "text-muted-foreground",
                (!item.tone || item.tone === "default") && "text-foreground"
              )}
            >
              {item.value}
            </span>
            {item.helperText && (
              <span className="text-[10px] font-medium text-muted-foreground/60">
                {item.helperText}
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
